/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = [".chartsWrap[_ngcontent-%COMP%]{\n  width: 100%;\n  height: 5rem;\n}"];
export { styles as styles };



// WEBPACK FOOTER //
// ./src/app/app-charts/app-charts.component.css.shim.ngstyle.js.pre-build-optimizer.js